/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  GetIcdcodesParams,
  IcdCodeStaffApiOutContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getIcdcodes = (
    params?: GetIcdcodesParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<IcdCodeStaffApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/icdcodes`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetIcdcodesInfiniteQueryKey = (params?: GetIcdcodesParams,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/icdcodes`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetIcdcodesQueryKey = (params?: GetIcdcodesParams,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/icdcodes`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetIcdcodesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getIcdcodes>>>, TError = void | ErrorApiOutContract>(params?: GetIcdcodesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIcdcodesInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIcdcodes>>> = ({ signal }) => getIcdcodes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIcdcodesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getIcdcodes>>>
export type GetIcdcodesInfiniteQueryError = void | ErrorApiOutContract


export function useGetIcdcodesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIcdcodes>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetIcdcodesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIcdcodes>>,
          TError,
          Awaited<ReturnType<typeof getIcdcodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIcdcodesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIcdcodes>>>, TError = void | ErrorApiOutContract>(
 params?: GetIcdcodesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIcdcodes>>,
          TError,
          Awaited<ReturnType<typeof getIcdcodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIcdcodesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIcdcodes>>>, TError = void | ErrorApiOutContract>(
 params?: GetIcdcodesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetIcdcodesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIcdcodes>>>, TError = void | ErrorApiOutContract>(
 params?: GetIcdcodesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIcdcodesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetIcdcodesInfiniteQuery = async <TData = Awaited<ReturnType<typeof getIcdcodes>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetIcdcodesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetIcdcodesInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetIcdcodesQueryOptions = <TData = Awaited<ReturnType<typeof getIcdcodes>>, TError = void | ErrorApiOutContract>(params?: GetIcdcodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIcdcodesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIcdcodes>>> = ({ signal }) => getIcdcodes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIcdcodesQueryResult = NonNullable<Awaited<ReturnType<typeof getIcdcodes>>>
export type GetIcdcodesQueryError = void | ErrorApiOutContract


export function useGetIcdcodes<TData = Awaited<ReturnType<typeof getIcdcodes>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetIcdcodesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIcdcodes>>,
          TError,
          Awaited<ReturnType<typeof getIcdcodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIcdcodes<TData = Awaited<ReturnType<typeof getIcdcodes>>, TError = void | ErrorApiOutContract>(
 params?: GetIcdcodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIcdcodes>>,
          TError,
          Awaited<ReturnType<typeof getIcdcodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIcdcodes<TData = Awaited<ReturnType<typeof getIcdcodes>>, TError = void | ErrorApiOutContract>(
 params?: GetIcdcodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetIcdcodes<TData = Awaited<ReturnType<typeof getIcdcodes>>, TError = void | ErrorApiOutContract>(
 params?: GetIcdcodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIcdcodesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetIcdcodesQuery = async <TData = Awaited<ReturnType<typeof getIcdcodes>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetIcdcodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetIcdcodesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetIcdcodesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getIcdcodes>>, TError = void | ErrorApiOutContract>(params?: GetIcdcodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIcdcodesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIcdcodes>>> = ({ signal }) => getIcdcodes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIcdcodesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getIcdcodes>>>
export type GetIcdcodesSuspenseQueryError = void | ErrorApiOutContract


export function useGetIcdcodesSuspense<TData = Awaited<ReturnType<typeof getIcdcodes>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetIcdcodesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIcdcodesSuspense<TData = Awaited<ReturnType<typeof getIcdcodes>>, TError = void | ErrorApiOutContract>(
 params?: GetIcdcodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIcdcodesSuspense<TData = Awaited<ReturnType<typeof getIcdcodes>>, TError = void | ErrorApiOutContract>(
 params?: GetIcdcodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetIcdcodesSuspense<TData = Awaited<ReturnType<typeof getIcdcodes>>, TError = void | ErrorApiOutContract>(
 params?: GetIcdcodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIcdcodesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetIcdcodesSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getIcdcodes>>>, TError = void | ErrorApiOutContract>(params?: GetIcdcodesParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIcdcodesInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIcdcodes>>> = ({ signal }) => getIcdcodes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIcdcodesSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getIcdcodes>>>
export type GetIcdcodesSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetIcdcodesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIcdcodes>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetIcdcodesParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIcdcodesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIcdcodes>>>, TError = void | ErrorApiOutContract>(
 params?: GetIcdcodesParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIcdcodesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIcdcodes>>>, TError = void | ErrorApiOutContract>(
 params?: GetIcdcodesParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetIcdcodesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIcdcodes>>>, TError = void | ErrorApiOutContract>(
 params?: GetIcdcodesParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIcdcodes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIcdcodesSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




